const SET_LIST = (state, obj) =>{
  state.list = obj.list
}
export default {
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/Role/store/mutations.js